import React from 'react';
import { colors } from '../../styles/colors';

/**
 * SectionCompact - Section compacte avec titre et icône
 *
 * @param {Object} props
 * @param {Component} props.icon - Composant icône Lucide
 * @param {string} props.title - Titre de la section
 * @param {string} props.bgColor - Couleur de fond du header
 * @param {ReactNode} props.children - Contenu de la section
 * @param {boolean} [props.isLast=false] - Si true, pas de marge en bas
 */
function SectionCompact({ icon, title, bgColor, children, isLast = false }) {
  return (
    <div style={{ marginBottom: isLast ? 0 : '0.5rem' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.375rem',
        padding: '0.375rem 0.5rem',
        backgroundColor: bgColor,
        borderRadius: '0.375rem 0.375rem 0 0',
        marginBottom: '0.25rem'
      }}>
        {icon}
        <span style={{
          fontSize: '0.75rem',
          fontWeight: '600',
          color: colors.primary.gray
        }}>
          {title}
        </span>
      </div>
      {children}
    </div>
  );
}

export default SectionCompact;
